// extracted by mini-css-extract-plugin
export default {"modalContent":"styles_modalContent__2E4KO","form":"styles_form__dKdKL","input":"styles_input__wNZci"};